import React from "react";
import { object, string, bool, oneOf } from "prop-types";
import cx from "classnames";

import ArrowLink from "../ArrowLink/ArrowLink.jsx";

const propTypes = {
  cta: object,
  title: string.isRequired,
  subtitle: string,
  centered: bool,
  noBorder: bool,
  darkTheme: bool,
  stacked: bool,
  size: oneOf(["", "large", "small", "x-small"]),
};

const sectionHeadline = (props) => {
  const { cta, title, subtitle, size, centered, noBorder, darkTheme, stacked } =
    props;

  const titleClass =
    size && size !== "" ? `section-headline__title--${size}` : "";

  return (
    <section
      className={cx("section-headline component container", {
        "section-headline--no-border": noBorder,
        "section-headline--centered": centered,
        [`section-headline--${size}`]: size,
        "section-headline--dark": darkTheme,
        "section-headline--stacked": stacked,
      })}
    >
      <h2 className={`section-headline__title ${titleClass}`}>{title}</h2>
      {!stacked && cta && cta.href && (
        <div className="section-headline__cta">
          <ArrowLink {...cta} type="arrow" />
        </div>
      )}
      {subtitle && (
        <div
          className="section-headline__subtitle"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
      {stacked && cta && cta.href && (
        <div className="section-headline__cta">
          <ArrowLink {...cta} type="arrow" />
        </div>
      )}
    </section>
  );
};

sectionHeadline.propTypes = propTypes;
export default sectionHeadline;
